import { __decorate } from "tslib";
import { Component } from "vue-property-decorator";
import { getOptionList } from "@/api/api-dict";
import { getDeviceOprPage, sendPileOperation } from "@/api/api-basic";
import { piUtSaveStorage } from "@/utils/utils";
import qrcodeShow from "@/components/qrcode/qrcode.vue";
import piSelectStation from "@/components/select-station/select-station.vue";
import piSelectTableData from "@/components/select-table-data/select-table-data.vue";
import tableMaxHeight from "@/mixins/table-max-height/table-max-height";
import { mixins } from "vue-class-component";
import i18n from "@/config/i18n";
let PiPileSList = class PiPileSList extends mixins(tableMaxHeight) {
    constructor() {
        super(...arguments);
        this.privilegeVoObj = {};
        this.formInline = {
            oprPkId: "",
            globalPageIndex: 1,
            globalPageSize: 10,
        };
        this.gunStatusColor = {
            "0": "warning",
            "1": "blue",
            "2": "error",
            "3": "default",
            "4": "default",
            "7": "success",
            "8": "primary",
            "9": "blue",
        };
        this.loading = false;
        this.staStatusList = [];
        this.total = 0;
        this.win = Window;
        this.tableList = [];
        this.tableColumns = [];
        this.allTableData = [
            {
                title: i18n.t("operatorId"),
                key: "operatorId",
                minWidth: 110,
            },
            {
                title: i18n.t("pileList.staName"),
                key: "staName",
                minWidth: 180,
            },
            {
                title: i18n.t("commonTableName.ratedPower"),
                key: "ratedPower",
                minWidth: 140,
            },
            {
                title: i18n.t("commonTableName.serialNumber"),
                key: "serialNumber",
                minWidth: 140,
            },
            {
                title: i18n.t("commonTableName.pileName"),
                key: "pileName",
                minWidth: 160,
                slot: "pileName",
            },
            {
                title: i18n.t("pileList.internalNumber"),
                key: "internalNumber",
                minWidth: 100,
            },
            {
                title: i18n.t("commonTableName.deviceType"),
                key: "deviceTypeDesc",
                minWidth: 130,
            },
            {
                title: i18n.t("pileList.deviceStatus"),
                key: "deviceStatusDesc",
                minWidth: 120,
                slot: "deviceStatusDesc",
            },
            {
                title: i18n.t("pileList.chargeGunInfoVoList"),
                key: "chargeGunInfoVoList",
                minWidth: 150,
                slot: "GunNo",
                className: "more-rows more-rows-border",
            },
            {
                title: i18n.t("pileList.gunStatus"),
                key: "chargeGunInfoVoList",
                minWidth: 100,
                slot: "gunStatus",
                className: "more-rows",
            },
            {
                title: i18n.t("pileList.gunOperation"),
                slot: "gunAction",
                width: 76,
            },
            {
                title: i18n.t("operation"),
                slot: "action",
                width: 140,
                className: " more-rows-border",
            },
        ];
    }
    tableChange(val) {
        this.formInline.globalPageIndex = val;
        this.getTableList();
    }
    tableSizeChange(val) {
        this.formInline.globalPageSize = val;
        this.getTableList();
    }
    searchClick() {
        this.formInline.globalPageIndex = 1;
        this.getTableList();
    }
    /**
     * 获取列表
     */
    async getTableList() {
        this.loading = true;
        const ret = await getDeviceOprPage(this.formInline);
        if (ret.status === this.$config.apiStatus) {
            this.total = ret.total;
            this.tableList = ret.data;
        }
        this.loading = false;
    }
    /**
     * 解锁
     */
    async showUnlock(row, item) {
        this.$Modal.confirm({
            title: i18n.t("tips") + "",
            content: i18n.t("pileList.showUnlockConfirm") + "",
            onOk: async () => {
                const ret = await sendPileOperation({
                    gunPkId: item.gunPkId,
                    operationType: 2,
                    serialNumber: row.serialNumber,
                    pilePkId: row.pilePkId,
                });
                if (ret.status === this.$config.apiStatus) {
                    this.$Message.success(i18n.t("pileList.showUnlockSuccess"));
                    this.getTableList();
                }
            },
        });
    }
    /**
     * 详情
     */
    detailClick(item) {
        piUtSaveStorage("/pile-manage/pile-list/pile-detail", item);
        this.$router.push("/pile-manage/pile-list/pile-detail?pilePkId=" + item.pilePkId);
    }
    /**
     * 修改
     */
    updataClick(item) {
        this.$router.push("/pile-manage/pile-list/pile-updata?pilePkId=" +
            item.pilePkId +
            "&staPkId=" +
            item.staPkId);
    }
    /**
     * 修改记录
     */
    updataClickRecord(item) {
        this.$router.push("/pile-manage/pile-list/pile-updata-record?pilePkId=" +
            item.pilePkId +
            "&staPkId=" +
            item.staPkId);
    }
    /**
     * 获取字典
     */
    getOptionList() {
        getOptionList(["12375"]).then((res) => {
            this.staStatusList = res["12375"];
        });
    }
    init() {
        //如果路由有带电话参数，则取出来
        if (this.$route.query.staPkId) {
            this.formInline.staPkId = this.$route.query.staPkId;
            this.formInline.globalPageIndex = 1;
            this.tableList = [];
        }
        if (this.tableList.length == 0) {
            // 刚进来或者无数据
            this.getTableList();
        }
        else if (this.$pageChildren.getSuccess("pile-info")) {
            // 有数据并在子页面操作了之后要刷新
            this.getTableList();
        }
    }
    mounted() {
        this.privilegeVoObj = this.$common.getPrivilegeVoObj(this.$route);
        this.getOptionList();
    }
    activated() {
        this.init();
    }
};
PiPileSList = __decorate([
    Component({
        components: {
            qrcodeShow,
            piSelectTableData,
            "pi-select-station": piSelectStation,
        },
    })
], PiPileSList);
export default PiPileSList;
